import axios from 'axios';
import Cookies from 'js-cookie';
import { config } from '../config';

const DEFAULT_API_BASE_URL = 'http://localhost:8080/api';
const API_BASE_URL = config?.API_URL || process.env.REACT_APP_API_URL || DEFAULT_API_BASE_URL;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = Cookies.get('auth_token');
  const hasAuthHeader = !!config?.headers?.Authorization;

  if (token && !hasAuthHeader) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const authHeader = error.config?.headers?.Authorization || '';
      const isGuestToken = authHeader.includes('Bearer') && !Cookies.get('auth_token');

      if (url.includes('/auth/signin') || url.includes('/auth/signup') || url.includes('/auth/verify-email') || url.includes('/users/sample-videos') || url.includes('/blog/') || isGuestToken || window.location.pathname === '/login') {
        return Promise.reject(error);
      }
      Cookies.remove('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  login: async (email, password) => {
    const response = await api.post('/auth/signin', { email, password });
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  logout: () => {
    Cookies.remove('auth_token');
  }
};

export default api;
